import * as i18n from "../../../i18n";
import {STORAGE} from "../storage";

export async function setAppLanguage() {
    // Set the app's language
    const languageSet = await STORAGE.get('language')
    const language = languageSet && 'en' !== languageSet ? languageSet : 'en'
    await i18n.setI18nConfig(language)
}